module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap-datetimepicker/~/babel-runtime/core-js/object/assign.js
// module id = 1261
// module chunks = 0